import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { LocalStoreService } from '../../services/local-store.service';
import { RealtimeDatabaseService } from '../../services/realtime-database.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService as CoreMessageService } from 'src/app/modules/core/services/message.service';
import { SupportChatService } from '../../services/support-chat.service';


@Component({
  selector: 'app-right-sidenav',
  templateUrl: './right-sidenav.component.html',
  styleUrls: ['./right-sidenav.component.scss'],
  providers: [MessageService, DialogService, DynamicDialogRef]
})
export class RightSidenavComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  isAuthenticated = false;
  @Output() closeRightSidenav = new EventEmitter();

  @Input() userBalance;
  @Input() username;

  balanceSubscription: Subscription;

  constructor(
    public router: Router,
    private authService: AuthService,
    private rdService: RealtimeDatabaseService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private coreMessageService: CoreMessageService,
    public supportChat: SupportChatService
  ) {
    this.subscription.add(authService.event.subscribe((data) => {
      this.username = data
    }));
  }

  // Mobile entry point for support chat — the sticky toolbar is display:none
  // under 1024px, so this drawer item is how phone users reach support. Only
  // rendered with the profile menu behind *ngIf="username", so
  // no login-required branch is needed here.
  async openSupportChat(): Promise<void> {
    this.closeRightSidenav.emit();
    try {
      await this.supportChat.open();
    } catch (e) {
      this.coreMessageService.showPopup(
        this.translateService.instant('SUPPORT.UNAVAILABLE'),
        'alert',
        'fail',
        'p0Popup'
      );
    }
  }

  getUserBalance() {
    if (this.balanceSubscription) { this.balanceSubscription.unsubscribe(); }
    this.balanceSubscription = this.rdService.getUserBalance().subscribe((res) => {
      if (this.userBalance && res[0] > this.userBalance) {
        this.messageService.clear();
        this.messageService.add({
          severity: 'success', summary: 'Success', life: 30000,
          detail: this.translateService.instant('ALERT.MONEY_HAS_BEEN_DEPOSITED')
        });
      }
      this.userBalance = res ? res[0] : '';
    });
  }

  ngOnInit(): void {
    this.subscription.add(this.authService.currentAuthStatus.subscribe((authStatus) => {
      this.isAuthenticated = !!authStatus;
      if (this.isAuthenticated) {
        this.getUserBalance();
      } else {
        this.balanceSubscription && this.balanceSubscription.unsubscribe();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
    this.balanceSubscription && this.balanceSubscription.unsubscribe();
  }

  logOut() {
    this.balanceSubscription && this.balanceSubscription.unsubscribe();
    this.authService.logOut();
  }
}
